// src/sections/PricingSection.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { getMeetingRoomsData, getCoworkingData } from "./PricingData";
import PricingCard from "./PricingCard";
import { ContainerGlob } from "../../../componentsGLob/ContainerGlob";

export default function PricingSection() {
  const { t } = useTranslation("pricing");

  const meetingRoomsData = getMeetingRoomsData(t);
  const coworkingData = getCoworkingData(t);

  return (
    <section id="pricing" className="relative bg-gray-100 py-12 md:py-16">
      {/* Contenuto principale della sezione */}
      <ContainerGlob className="group/tiers relative z-10">
        <div className="mx-auto max-w-4xl text-center space-y-6">
          <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
            {t("sectionTitle")}
          </h2>
          <p className="text-lg font-medium text-gray-600 sm:text-xl">
            {t("sectionSubtitle")}
          </p>
        </div>
        <div className="mt-12 flex justify-center">
          <fieldset aria-label="Payment frequency">
            <div className="grid grid-cols-2 gap-x-1 rounded-full p-1 text-center text-xs font-semibold ring-1 ring-inset ring-gray-200">
              {/* Coworking */}
              <label className="group relative rounded-full px-3 py-1.5 has-checked:bg-indigo-600">
                <input
                  defaultValue="coworking"
                  defaultChecked
                  name="kind"
                  type="radio"
                  className="absolute inset-0 appearance-none rounded-full"
                />
                <span className="text-gray-500 group-has-checked:text-white">
                  {t("tabs.coworking")}
                </span>
              </label>

              {/* Spazi */}
              <label className="group relative rounded-full px-3 py-1.5 has-checked:bg-indigo-600">
                <input
                  defaultValue="spaces"
                  name="kind"
                  type="radio"
                  className="absolute inset-0 appearance-none rounded-full"
                />
                <span className="text-gray-500 group-has-checked:text-white">
                  {t("tabs.spaces")}
                </span>
              </label>
            </div>
          </fieldset>
        </div>
        <div className="mt-12 min-h-[700px] transition-all duration-300 ease-in-out">
          {/* Coworking */}
          <div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8
                group-not-has-[[name=kind][value=coworking]:checked]/tiers:hidden"
          >
            {coworkingData.cards.map((card) => (
              <PricingCard key={card.id} card={card} />
            ))}
          </div>

          {/* Meeting Rooms */}
          <div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 lg:gap-8
                group-not-has-[[name=kind][value=spaces]:checked]/tiers:hidden"
          >
            {meetingRoomsData.cards.map((card) => (
              <PricingCard key={card.id} card={card} />
            ))}
          </div>
        </div>
      </ContainerGlob>
    </section>
  );
}
